// ═══════════════════════════════════════════════════════════════
// HotWash — Module Layout with sub-navigation
// ═══════════════════════════════════════════════════════════════

import { Outlet, useLocation } from 'react-router-dom';
import {
  IconLayoutDashboard, IconEye, IconPlus, IconChartBar, IconUpload,
} from '@tabler/icons-react';
import { useFilteredNav } from '../../hooks/useFilteredNav';
import type { NavItem } from '../../types/nav';
import { brand } from '../../lib/colors';
import Breadcrumbs from '../../components/ui/Breadcrumbs';
import ModuleNav from '../../components/layout/ModuleNav';

const NAV_ITEMS: NavItem[] = [
  { label: 'Dashboard', path: '/hotwash', icon: IconLayoutDashboard, exact: true },
  { label: 'Observations', path: '/hotwash/observations', icon: IconEye },
  { label: 'Submit', path: '/hotwash/submit', icon: IconPlus },
  { label: 'Analytics', path: '/hotwash/analytics', icon: IconChartBar, minLevel: 'editor' },
  { label: 'Import', path: '/hotwash/import', icon: IconUpload, minLevel: 'editor' },
];

export default function HotWashLayout() {
  const { pathname } = useLocation();
  const visibleItems = useFilteredNav('hotwash', NAV_ITEMS);

  const isDetail = pathname.startsWith('/hotwash/incident/');

  const currentPage = NAV_ITEMS.find(item =>
    item.exact ? pathname === item.path : pathname.startsWith(item.path)
  );

  return (
    <div style={{ padding: '24px' }}>
      {!isDetail && (
        <>
          <Breadcrumbs
            items={[
              { label: 'Hub', to: '/' },
              { label: 'HotWash', to: '/hotwash' },
              ...(currentPage && currentPage.path !== '/hotwash' ? [{ label: currentPage.label }] : []),
            ]}
          />
          <ModuleNav items={visibleItems} accentColor={brand.blurple} />
        </>
      )}
      <Outlet />
    </div>
  );
}
